import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBDateInput, renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import { apiCallFailure } from 'app/actions';
import * as valid from 'utils/validate';
import { DAY_TIME_HM } from 'app/constants';
import { api,
apiUtils } from 'app/services';
import {
KBPopover,
KBPopoverTop,
KBUserInput,
KBFormError,
KBButton,
KBToReportCenter } from
'components';
import dayjs from 'utils/dayjs';
import { EXPORT_HINT } from 'app/constants/hint';
import { getServiceErrorMessage } from 'utils/kbUtil';

var MeetingRoomReportForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.toReportCenter = this.toReportCenter.bind(this);this.reportMeetingRoom = this.reportMeetingRoom.bind(this);this.changeStartYMDCallback = this.changeStartYMDCallback.bind(this);this.changeEndYMDCallback = this.changeEndYMDCallback.bind(this);this.changeStartHMCallback = this.changeStartHMCallback.bind(this);this.changeEndHMCallback = this.changeEndHMCallback.bind(this);this.setYMD = this.setYMD.bind(this);this.setHM = this.setHM.bind(this);this.getDisabledDays = this.getDisabledDays.bind(this);}getInitialState()
  {
    return {};
  }componentDidMount()

  {
    const {
      fields: { startYMD, startHM, endHM } } =
    this.props;
    let defaultStartDate = dayjs().
    subtract(1, 'weeks').
    format('YYYY-MM-DD');
    this.changeStartHMCallback('0,1');
    this.changeEndHMCallback('24,1');
    startHM.onChange('0,1');
    endHM.onChange('24,1');
    setTimeout(() => {
      this.changeStartYMDCallback(defaultStartDate);
    });
    startYMD.onChange(defaultStartDate);
  }toReportCenter()

  {
    KBPopoverTop.show(
    <KBToReportCenter
    title="Excel导出"
    message="Excel已成功导出，可以前往报表中心下载" />);


  }reportMeetingRoom(

  model) {
    const { loc_id } = this.props;
    const { start_time, end_time } = model;
    let params = Object.assign(
    {},
    {
      start_at: dayjs(start_time).format('YYYY-MM-DD HH:mm:ss'),
      end_at: dayjs(end_time).format('YYYY-MM-DD HH:mm:ss'),
      location_id: loc_id });


    const { apiCallFailureActions } = this.props;

    return api.postMeetingRoomReport(params).then(() => {
      this.toReportCenter && this.toReportCenter();
    },
    error =>
    apiCallFailureActions({
      status: 'error',
      message: getServiceErrorMessage(error) || '导出会议室记录失败，请稍后重试' }));
  }changeStartYMDCallback(

  data) {
    const {
      fields: { start_time } } =
    this.props;
    this.setYMD(start_time, data);
  }changeEndYMDCallback(

  data) {
    const {
      fields: { end_time } } =
    this.props;
    this.setYMD(end_time, data);
  }changeStartHMCallback(

  data) {
    const {
      fields: { start_time } } =
    this.props;
    this.setHM(start_time, data);
  }changeEndHMCallback(

  data) {
    const {
      fields: { end_time } } =
    this.props;
    this.setHM(end_time, data);
  }setYMD(

  field, value) {
    let date = dayjs(value);
    let year = date.get('year');
    let month = date.get('month');
    let day = date.get('date');
    field.onChange(
    dayjs(field.value).
    clone().
    set({ year, month, date: day }).
    toDate());

  }setHM(

  field, value) {
    let t = value.split(',');
    let isLastHour = t[0] === 24 || t[0] === '24';
    field.onChange(
    dayjs(field.value).
    clone().
    set({
      hour: isLastHour ? 23 : t[0],
      minute: t[1] == '1' ? isLastHour ? 59 : 0 : 30,
      second: 0 }).

    toDate());

  }getDisabledDays(

  date) {
    // 最近6个月
    const earliest = dayjs().subtract(6, 'month');
    const day = dayjs(date);
    const today = dayjs();
    return !day.isBetween(earliest, today);
  }render()

  {
    const {
      fields: { startYMD, startHM, endYMD, endHM, start_time, end_time },
      error,
      submitting,
      handleSubmit,
      DEAL_DAY_TIME_HM } =
    this.props;
    var halfClass = {
      className: 'kb-form-group kb-div-c48' };

    return (
      <form onSubmit={handleSubmit(this.reportMeetingRoom)}>
        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <h2 className="header-title">导出会议室记录</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container-m">
          <div className="kb-row kb-form-66">
            <Field name="startYMD" component={renderKBDateInput}
            type="date"
            title="开始日期"
            isRequired={true}
            className="kb-form-group kb-div-48"

            disabledDays={this.getDisabledDays}
            onChange={this.changeStartYMDCallback} />

            <Field name="startHM" component={renderKBSelect}
            title="开始时间"
            onChange={this.changeStartHMCallback}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}

            {...halfClass} />

          </div>
          <div className="kb-row kb-form-66">
            <Field name="endYMD" component={renderKBDateInput}
            type="date"
            title="结束日期"
            isRequired={true}
            className="kb-form-group kb-div-48"

            disabledDays={this.getDisabledDays}
            onChange={this.changeEndYMDCallback} />

            <Field name="endHM" component={renderKBSelect}
            title="结束时间"
            onChange={this.changeEndHMCallback}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}

            {...halfClass} />

          </div>
          <p style={{ fontSize: '12px', color: '#7F8FA4' }}>{EXPORT_HINT.concat_admin}</p>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  let DEAL_DAY_TIME_HM = DAY_TIME_HM(0, 24);
  return {
    DEAL_DAY_TIME_HM };

}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};

  if (
  values.start_time &&
  values.end_time &&
  dayjs(values.end_time).diff(dayjs(values.start_time)) <= 0)
  {
    errors.endHM = '结束日期必须大于开始日期';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "start_time",
  "end_time",
  "startHM",
  "endHM",
  "startYMD",
  "endYMD"
];

const formConfig = {
  form: 'LockPermissionsMultiForm',
  validate: validate,
  touchOnBlur: false };


MeetingRoomReportForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LockPermissionsMultiForm', LEGACY_FORM_FIELDS)(MeetingRoomReportForm)));

export default MeetingRoomReportForm;
